import { AxiosPromise } from 'axios';

import {
  CoverageLanguage,
  EEntityType,
  GetTranslationEntitiesParams,
  LanguageListItem,
  PaginatedResponse,
  TranslationEntityItem,
  TranslationRecord,
  UpsertTranslationDto,
} from 'shared/api';
import { apiInstance } from 'shared/api/typicode/base';

const BASE_URL = '/translations';

const authHeaders = () => ({
  Authorization: `Bearer ${window.localStorage.getItem('token') ?? ''}`,
});

/**
 * Языки, для которых уже есть хотя бы одна запись перевода.
 */
export const getLanguages = async (): AxiosPromise<LanguageListItem[]> =>
  apiInstance.get(`${BASE_URL}/languages`, { headers: authHeaders() });

/**
 * Матрица покрытия — 29 элементов (все целевые языки).
 */
export const getCoverageMatrix = async (): AxiosPromise<CoverageLanguage[]> =>
  apiInstance.get(`${BASE_URL}/coverage`, { headers: authHeaders() });

/**
 * Пагинированный список сущностей с переводами для пары (entityType, language).
 */
export const getEntities = async (
  entityType: EEntityType,
  params: GetTranslationEntitiesParams,
): AxiosPromise<PaginatedResponse<TranslationEntityItem>> =>
  apiInstance.get(`${BASE_URL}/entities/${entityType}`, {
    params,
    headers: authHeaders(),
  });

/**
 * Upsert перевода — создаёт или обновляет запись для пары
 * (entityType, entityId, language).
 */
export const upsert = async (dto: UpsertTranslationDto): AxiosPromise<TranslationRecord> =>
  apiInstance.post(`${BASE_URL}`, dto, { headers: authHeaders() });
